export enum EmployeeShiftEndEnum {
  BUSINESS_DECLINE = 'BusinessDecline',
  CLOSING_SHIFT = 'ClosingShift',
}
export enum BidTypeStatus {
  OPENBID = 'Bid',
  CANCELBID = 'Cancel Bid',
}

export enum EmployeeShiftTypeEnum {
  CLOSED = 'Closed',
  OPEN = 'Open',
  RELEASED = 'Released',
  SWAP = 'Swap',
}

export enum GetEmployeeShiftStatus {
  MY_OWN = 'MyOwn',
  ALL = 'All',
}

export enum EmployeeShiftValidationStatus {
  CONFLICT = 'Conflict',
  AVAILABILITY_CONFLICT = 'Availability Conflict',
  TIMEOFF_CONFLICT = 'TimeOff Conflict',
  OVERTIME = 'Overtime',
  DAILY_OVERTIME = 'Daily Overtime',
  WEEKLY_OVERTIME = 'Weekly Overtime',
  NONE = 'None',
}

export enum NotifyEmployees {
  ALL = 'All',
  AFFECTED = 'Affected',
  NONE = 'None',
}

export interface Role {
  id: number;
  roleName: string;
  name?: string;
}

export interface Employee {
  id: string;
  name: string;
  image?: string;
  displayId: number;
  phoneNumber?: string | null;
}

export interface EmployeeShift {
  id: number;
  date: Date;
  type: EmployeeShiftTypeEnum;
  startTime: string;
  endTime: string;
  shiftHours: number;
  published: boolean;
  shiftEnd?: EmployeeShiftEndEnum;
  notes?: string;
  createdAt: Date;
  role: Role;
  employee?: Employee | null;
}

export interface RoleEmployeeShift {
  shiftsCount: number;
  role: Role;
  shifts: EmployeeShift[];
}

export interface GetEmployeeShiftResponse {
  date: string;
  totalShifts: number;
  unPublishedShiftsCount: number;
  openShiftsCount: number;
  roleShiftsCount: number;
  unPublishedShifts: EmployeeShift[];
  openShifts: EmployeeShift[];
  roleShifts: RoleEmployeeShift[];
}

export enum EmpShiftTypes {
  EDIT_SHIFT = 'edit_shift',
  ANOTHER_SHIFT = 'another_shift', // Example: replace with actual shift types
}
